import PropTypes from 'prop-types';
import React from 'react'; // eslint-disable-line no-unused-vars
import fieldPropTypes from './field';

const { arrayOf, number, oneOfType, shape, string } = PropTypes;

export default shape({
  rowID: string,
  tableID: string,
  rowNumber: oneOfType([number, string]),
  fields: arrayOf(fieldPropTypes)
});



// WEBPACK FOOTER //
// ./js/types/api/tableRow.js